<template>
  <div class="wrap">
    <mescroll-vue class="mescroll" :class="{'mescroll1':isIos}" ref="mescroll" :down="mescrollDown" :up="mescrollUp"
                  @init="mescrollInit">

      <!--Banner-->
      <banner :data="bannerList"></banner>
      <!--5个图标-->
      <div class="typeBox white">
        <van-grid :column-num="5" :border="false">
          <van-grid-item v-for="(item,i) in typeList" :key="i" @click="jumpType(item)">
            <img slot="icon" :src="item.icon" alt=""/>
            <div slot="text" class="f14">{{ item.title }}</div>
          </van-grid-item>
        </van-grid>
      </div>
      <!--特色产品-->
      <div class="specialBox">
        <div class="item" v-for="(item,i) in specialList" :key="i" :class="{'bl': i%2===1, 'bt': i>1}"
             @click="$router.push('/whyd/ydDetail?ydId='+item.goodsId)">
          <div class="pub_left f16 bold_f"><b>{{ item.type|getType }}</b></div>
          <div class="pub_left f14 overell">{{ item.goodsName }}</div>
          <div class="flex flex_start">
            <img :src="item.goodsImage" v-lazy="item.goodsImage" mode="widthFix"/>
            <div class="priceBox">
              <div class="line"><span>￥{{ item.price }}</span></div>
              <div class="line"><span class="through gray_f f10">￥{{ item.oriPrice }}</span></div>
              <div class="line"><span class="_coupon f12">{{ Number(item.coupon).toFixed(0) }}元券</span>
              </div>
              <div class="line"><span class="_tongBan f12">{{ item.tongBan }}铜板</span></div>
            </div>
          </div>
        </div>
      </div>
      <div class="white ">
        <div class="pub_center" style="margin: 18px 0 10px;">
          <img src="https://m.whsq365.com/wohuisq/static/wxapp/image/detail/cainixihuan.png" mode="widthFix"
               style="width: 60%"/>
        </div>
        <div class="list" id="listId">
          <div v-for="(item, i) in dataList" :key="i" class="white">
            <goodsItem :item="item" layoutType="0" source="YD"></goodsItem>
          </div>
        </div>
      </div>
    </mescroll-vue>
  </div>
</template>

<script>
import {ydIndex} from "../../../api/commonV2";

export default {
  name: 'fine',
  data() {
    return {
      bannerList: [], //bannber
      typeList: [], //5个类别按钮
      specialList: [], //特色主题
      dataList: [] //产品列表
    }
  },
  filters: {
    getType(val) {
      switch (val) {
        case '1':
          return '购•特色'
          break
        case '2':
          return '购•好货'
          break
        case '3':
          return '爱•逛街'
          break
        case '4':
          return '爱•生活'
          break
      }
    }
  },
  methods: {
    // 上拉加载
    upCallback(val) {
      let data = {
        pageNo: val.num,
        pageSize: val.size
      }
      ydIndex(data).then(res => {
        if (res.result === '0') {
          if (val.num === 1) {
            this.dataList = []
          }
          //传递分类到父组件
          this.$emit('initData', res.cateList)
          this.bannerList = res.bannerList;
          this.typeList = res.typeList;
          this.specialList = res.specialList;
          res.dataList ? this.dataList = this.dataList.concat(res.dataList) : ''
          this.mescroll.endByPage(res.dataList.length, res.totalPage)
        }
      }, err => {
        this.mescroll.endErr()
      })
    },
    //5个菜单按钮
    jumpType(item) {
      let type = item.type;
      let name = item.title;
      console.log("item=" + JSON.stringify(item))
      let url = "";
      switch (type) {
        case "0":
          break;
        case "1":
          url = "/whyd/ydZone?zoneType=1&zoneName=" + name
          break;
        case "2":
          url = "/whyd/ydZone?zoneType=3&zoneName=" + name;
          break;
        case "3":
          url = "/whyd/ydCate1List?cate1Id=272&cate1Name=9.9包邮";
          break;
        case "4":
          url = "/whyd/c2fLiuYan";
          break;
      }
      this.$router.push(url)
    }
  }
}
</script>

<style scoped lang="less">
.wrap {
  background: #FFF;
}

.typeBox {
  img {
    width: 40px;
    height: 40px;
  }
}

.specialBox {
  display: flex;
  flex-wrap: wrap;

  .item {
    width: 50%;
    /*margin:0 2%;*/
    padding-left: 2%;
    padding-bottom: 2%;
    padding-top: 2%;

    img {
      width: 50%;
    }

    .priceBox {
      text-align: left;
      margin-left: 3px;

      .line {
        padding: 2px 4px;
      }
    }
  }

  .bl {
    border-left: 1px solid #f0f0f0;
  }

  .bt {
    border-top: 1px solid #f0f0f0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/tabBar/whyd/fine.vue